var _excluded = ["type", "inspire"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * @class Oskari.mapframework.bundle.mapuserdatalayer.domain.UserDataLayerModelBuilder
 * JSON-parsing for user own layers (myplaces, userlayer, analysis)
 */
export var UserDataLayerModelBuilder = /*#__PURE__*/function () {
  function UserDataLayerModelBuilder(sandbox) {
    _classCallCheck(this, UserDataLayerModelBuilder);
    this.sandbox = sandbox;
    this.types = {};
  }
  return _createClass(UserDataLayerModelBuilder, [{
    key: "registerLayerType",
    value: function registerLayerType(layerService, options) {
      var type = options.type,
        inspire = options.inspire,
        toStore = _objectWithoutProperties(options, _excluded);
      var dataProviderId = -10 * Oskari.getSeq('usergeneratedDataProvider').nextVal();
      var provider = {
        id: dataProviderId,
        name: inspire
      };
      layerService.addDataProvider(provider);

      // negative value for group id means that admin isn't presented with tools for it (-1 is reserved for default group)
      var group = {
        id: -10 * Oskari.getSeq('usergeneratedGroup').nextVal(),
        name: inspire
      };
      layerService.addLayerGroup(Oskari.clazz.create('Oskari.mapframework.domain.MaplayerGroup', group));
      this.types[type] = _objectSpread({
        group: group,
        dataProviderId: dataProviderId
      }, toStore);
    }

    /**
     * Parses any additional fields to model
     *
     * @param {UserDataLayer} layer partially populated layer
     * @param {Object} mapLayerJson JSON presentation of the layer
     */
  }, {
    key: "parseLayerData",
    value: function parseLayerData(layer, mapLayerJson) {
      var _this = this;
      var locale = mapLayerJson.locale,
        type = mapLayerJson.type,
        describeLayer = mapLayerJson.describeLayer;
      if (!this.types[type]) {
        // type is not registered
        return;
      }
      var _this$types$type = this.types[type],
        group = _this$types$type.group,
        dataProviderId = _this$types$type.dataProviderId,
        editRequest = _this$types$type.editRequest,
        organization = _this$types$type.organization,
        _this$types$type$crea = _this$types$type.createTools,
        createTools = _this$types$type$crea === void 0 ? [] : _this$types$type$crea;
      layer.setLocale(locale);
      layer.preHandleDescribeLayer(describeLayer);
      layer.setOrganizationName(organization);
      layer.setDataProviderId(dataProviderId);
      layer.setGroups([group]);
      if (editRequest) {
        // Add edit layer tool
        var toolName = Oskari.getMsg('MapWfs2', 'editLayer');
        var toolOwnStyle = Oskari.clazz.create('Oskari.mapframework.domain.Tool');
        toolOwnStyle.setName('editStyle');
        toolOwnStyle.setIconCls('show-own-style-tool');
        toolOwnStyle.setTooltip(toolName);
        toolOwnStyle.setTitle(toolName);
        toolOwnStyle.setCallback(function () {
          return _this.sandbox.postRequestByName(editRequest, [layer.getId()]);
        });
        layer.addTool(toolOwnStyle);
      }
      createTools.forEach(function (createTool) {
        if (typeof createTool === 'function') {
          layer.addTool(createTool(layer));
        }
      });
    }
  }]);
}();